// extracted by mini-css-extract-plugin
export default {"powerSavingsValue":"LocationPopup_powerSavingsValue__sIN8K","wrapper":"LocationPopup_wrapper__GWYld"};